// packages/shared/src/constants.ts
/** Backend API path prefix */
export const API_BASE = "/api";
/** Backend Entra application roles. */
export const APP_ROLES = {
    user: "Excalidraw.User",
    admin: "Excalidraw.Admin",
    metricsReader: "Excalidraw.Metrics.Reader",
};
/** API endpoint paths */
export const API_PATHS = {
    health: `${API_BASE}/health`,
    me: `${API_BASE}/me`,
    profile: `${API_BASE}/profile`,
    analyticsImpact: `${API_BASE}/analytics/impact`,
    analyticsImpactCore: `${API_BASE}/analytics/impact/core`,
    telemetryEvents: `${API_BASE}/telemetry/events`,
    telemetryActivity: `${API_BASE}/telemetry/activity`,
    drawingsMine: `${API_BASE}/drawings/mine`,
    drawingsShared: `${API_BASE}/drawings/shared`,
    drawingsCreate: `${API_BASE}/drawings`,
    storagePrepare: `${API_BASE}/storage/prepare`,
    drawing: (drawingId) => `${API_BASE}/drawings/${drawingId}`,
    drawingDuplicate: (drawingId) => `${API_BASE}/drawings/${drawingId}/duplicate`,
    drawingCopyAbandon: (drawingId) => `${API_BASE}/drawings/${drawingId}/copy-abandon`,
    drawingGalleryDetails: `${API_BASE}/drawings/gallery-details`,
    drawingPreview: (drawingId) => `${API_BASE}/drawings/${drawingId}/preview`,
    drawingShare: (drawingId) => `${API_BASE}/drawings/${drawingId}/share`,
    drawingShareRedeem: `${API_BASE}/drawings/shares/redeem`,
    drawingReference: (drawingId) => `${API_BASE}/drawings/${drawingId}/reference`,
    drawingReferenceOpen: `${API_BASE}/drawings/references/open`,
    usersSearch: `${API_BASE}/users/search`,
    session: `${API_BASE}/session`,
    feedback: `${API_BASE}/feedback`,
    // Compatibility aliases (legacy names)
    sessionJoin: `${API_BASE}/session`,
    sessionEphemeral: `${API_BASE}/session`,
    sharingExport: `${API_BASE}/sharing/export`,
    sharingView: (blobId) => `${API_BASE}/sharing/view/${blobId}`,
};
/** WebSocket collaboration endpoint path — must be under /api/* for SWA Linked Backend proxying */
export const COLLAB_WS_PATH = "/api/collab";
/** Room ID derivation config */
export const ROOM_ID_LENGTH = 32; // hex chars from SHA-256 (128 bits for collision safety)
/** Deterministic user color from userId (OID). Returns HSL-based background + stroke. */
export function userColor(userId) {
    let hash = 0;
    for (let i = 0; i < userId.length; i++) {
        hash = ((hash << 5) - hash + userId.charCodeAt(i)) | 0;
    }
    const hue = ((hash % 360) + 360) % 360;
    return {
        background: `hsl(${hue}, 70%, 92%)`,
        stroke: `hsl(${hue}, 70%, 45%)`,
    };
}
//# sourceMappingURL=constants.js.map